import { PropsWithChildren } from 'react';
import cn from 'classnames';
import { createPortal } from 'react-dom';
import styles from './modal-background.module.scss';

export type ModalBackgroundProps = PropsWithChildren & {
  className?: string;
  isModalOpened: boolean;
  replaceBlockHeight: string;
  setModalOpened: (isModalOpened: boolean) => void;
};

export const ModalBackground = ({
  className,
  children,
  isModalOpened,
  replaceBlockHeight,
  setModalOpened,
}: ModalBackgroundProps) => {
  const closeModal = () => {
    setModalOpened(false);
  };

  return (
    <>
      {createPortal(
        <div
          className={cn(styles.overlay, className, {
            [styles['overlay-opened']]: isModalOpened,
          })}
          onClick={closeModal}
        />,
        document.body,
      )}

      <div
        className={cn(styles.replaceBlock, {
          [styles['replaceBlock-show']]: isModalOpened,
        })}
        style={{ height: replaceBlockHeight }}
      />

      <div
        className={cn(styles.wrapper, {
          [styles['wrapper-opened']]: isModalOpened,
        })}
      >
        {children}
      </div>
    </>
  );
};
